<style lang="scss">
  .excel-simple-import{
    .el-upload-list {
      position: absolute;
      width: 730px;
      .el-upload-list__item {
        margin: 0;
      }
    }
  }
</style>
<template>
  <div class="simple-import">
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form" :width="formDialogWidth" @close="handleDialogClose" :append-to-body="true">
      <div slot="title" class="popup-head">
        <span class="popup-tit">{{ importConfig.title || '&nbsp;' }}</span>
      </div>
      <div v-loading="loading">
        <div class="popup-body">
          <div class="popup-content">
            <div class="import-top excel-simple-import">
              <el-upload
                drag
                :ref="'excelUpload'"
                :action="excelUploadUrl"
                :headers="uploadHeaders"
                :name="'upload'"
                :data="uploadExtraParams"
                :auto-upload="false"
                :limit="1"
                :on-progress="handleFileUploadProgress"
                :on-success="handleFileUploadSuccess"
                :on-error="handleFileUploadError"
                :on-exceed="handleFileUploadExceed">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              </div>
              <div class="import-bot">
                <ul class="clearfix">
                  <li class="import-cell" style="width: 45%;">
                    <h5 style="margin-left: 20px;">模板下载</h5>
                    <p class="info">
                      <a @click="handleExcelTemplateDownload" class="link-normal">点击下载模板</a>
                    </p>
                    <div v-show="importResultDownLoadUrl">
                      <h5 style="margin-left: 20px;">导入结果下载</h5>
                      <p class="info">
                        <a @click="handleImportResultDownLoad" class="btn-link">点击下载导入结果</a>
                      </p>
                    </div>
                  </li>
                  <li class="import-cell" style="width: 55%;" v-show="visible">
                    <h5 style="margin-left: 20px;">说明</h5>
                    <p class="info" v-if="importConfig.info" v-html="importConfig.info">
                      第一步，下载导入模板<br>
                      第二步，上传Excel<br>
                      第三步，导入结束后，会显示导入结果，如有导入失败的数据，系统会返回Excel文件，可下载查看导入失败的原因
                    </p>
                    <p class="info" v-if="!importConfig.info">
                      第一步，下载导入模板<br>
                      第二步，上传Excel<br>
                      第三步，导入结束后，会显示导入结果，如有导入失败的数据，系统会返回Excel文件，可下载查看导入失败的原因
                    </p>
                  </li>
                </ul>
              </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="popup-foot group">
        <a href="javascript:" class="btn btn btn-anti-default" @click="handleCancel">取消</a>
        <a href="javascript:" class="btn btn btn-solid-primary" @click="handleSubmit">导入</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import util from '../../libs/util'

  export default {
    name: 'excel-import-simple',
    props: {
      importConfig: {
        type: Object,
        default() {
          return {
            title: 'excel导入',
            excelTemplateDownloadUrl: '', // 下载导入模板的地址
            excelUploadUrl: '', // excel文件上传地址
            downloadExtraParams: {}, // 下载模板时传递的额外参数
            uploadExtraParams: {}, // 上传时传递的额外参数
            info: '', // 说明信息,可以是html
            sendRowId: false
          }
        }
      },
      checkedRows: {
        type: Array,
        default() {
          return []
        }
      }
    },
    computed: {
      formDialogWidth: function () {
        return '800px'
      },
      // 文件上传时添加的headers
      uploadHeaders: function () {
        return {
          'Authorization': util.bearerToken()
        }
      },
      excelUploadUrl: function () { // 上传的url
        return util.baseUrl + this.importConfig.excelUploadUrl
      },
      downloadExtraParams: function () { // 下载时传递的额外参数
        if (this.importConfig.sendRowId) {
          if (!this.importConfig.downloadExtraParams) {
            this.importConfig.downloadExtraParams = {}
          }
          this.importConfig.downloadExtraParams['ids'] = this.checkedRows.join(',')
        }
        return this.importConfig.downloadExtraParams
      },
      uploadExtraParams: function () { // 上传时传递的额外参数
        if (this.importConfig.sendRowId) {
          if (!this.importConfig.uploadExtraParams) {
            this.importConfig.uploadExtraParams = {}
          }
          this.importConfig.uploadExtraParams['ids'] = this.checkedRows.join(',')
        }
        return this.importConfig.uploadExtraParams
      }
    },
    data() {
      return {
        visible: false,
        loading: false,
        importResultDownLoadUrl: '' // 导入结果下载地址
      }
    },
    methods: {
      show() {
        this.visible = true
      },
      hide() {
        this.visible = false
      },
      handleDialogClose() {
        // 清除掉已经上传的文件列表
        this.clearFiles()
        this.importResultDownLoadUrl = ''
        this.$emit('close')
      },
      clearFiles() {
        this.$refs.excelUpload.clearFiles()
      },
      handleSubmit() {
        this.$refs.excelUpload.submit()
      },
      handleCancel() {
        this.hide()
      },
      handleExcelTemplateDownload() {
        util.useFormSubmit(util.baseUrl + this.importConfig.excelTemplateDownloadUrl, this.downloadExtraParams, true)
      },
      handleImportResultDownLoad() {
        util.useFormSubmit(util.baseUrl + this.importResultDownLoadUrl, null, true)
      },
      // 文件上传成功钩子
      handleFileUploadSuccess(response, file, fileList) {
        if (response.meta.errCode === 0) {
          let ul = document.querySelector('.excel-simple-import .el-upload-list')
          ul.firstElementChild.style.display = 'block'
          ul.lastElementChild.remove()
          this.$notify.success({title: '成功', message: response.meta.errMsg})
        } else {
          this.$notify.warning({title: '警告', message: '导入失败,原因：' + response.meta.errMsg})
        }
      },
      // 文件上传时钩子
      handleFileUploadProgress(response, file, fileList) {
        if (response.percent >= 100) {
          let ul = document.querySelector('.excel-simple-import .el-upload-list')
          let myli = document.createElement('li')
          myli.className = 'el-upload-list__item'
          myli.innerHTML = '数据处理中,请稍等...'
          ul.appendChild(myli)
          ul.firstElementChild.style.display = 'none'
        }
      },
      // 文件上传失败钩子
      handleFileUploadError(err, file, fileList) {
        let ul = document.querySelector('.excel-simple-import .el-upload-list')
        ul.firstElementChild.style.display = 'block'
        ul.lastElementChild.remove()
        console.error(err)
        this.$notify.error({title: '错误', message: '错误,文件上传失败！'})
      },
      // 文件超出个数限制时的钩子
      handleFileUploadExceed(file, fileList) {
        this.$notify.info({title: '提示', message: '添加失败,超出允许上传的文件个数！'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/excel-import/excel-import-simple.vue